<template>
  <div>
    <v-container fluid>
      <v-layout>
        <v-flex>

          <v-row justify="center" class="ma-0">
            <v-col cols="12"
                   :lg="$vuetify.breakpoint.width > 1400 ? '10': '11'"
                   md="11"
                   sm="12"
                   xs12
                   class="d-flex row"
                   :class="{'mt-3 px-6': $vuetify.breakpoint.smOnly, 'mt-1 px-3': $vuetify.breakpoint.xsOnly, 'mt-8': $vuetify.breakpoint.mdAndUp}"
            >
              <div class="chipFiltersContainer">
                <span class="mr-6 d-flex align-center" v-if="$vuetify.breakpoint.smAndUp">Filter by:</span>
                <ChipFilter id="method" name="Method" :items="notificationMethods" v-model="filterMethod"/>
                <ChipFilter id="status" name="Status" :items="notificationStatuses" v-model="filterStatus"/>
                <AdsButton tertiary button-text="Clear all" style="height: 30px;" @click="clearAllFilters"/>
              </div>
            </v-col>
          </v-row>

          <v-row justify="center" class="mx-0 mt-4 mb-10">
            <v-col cols="12"
                   :lg="$vuetify.breakpoint.width > 1400 ? '10': '11'"
                   md="11"
                   sm="12"
                   xs12
                   :class="{'pt-0 px-6': $vuetify.breakpoint.smOnly, 'pt-0 px-0': $vuetify.breakpoint.xsOnly}"
            >
              <DataTable :headers="tableHeaders" :rows="notifications" :filters="filters"/>
            </v-col>
          </v-row>

        </v-flex>
      </v-layout>
    </v-container>
  </div>
</template>

<script>
import ChipFilter from "@/components/ChipFilter";
import DataTable from "@/components/qPlus/DataTable";
import {AdsButton} from '@nswdoe/doe-ui-core';

export default {
  name: 'Dashboard',
  components: {
    ChipFilter,
    DataTable,
    AdsButton
  },
  data: () => ({
    tableHeaders: [
      {
        text: 'ID',
        align: 'start',
        value: 'draftId'
      },
      {
        text: 'Notification Name',
        align: 'start',
        value: 'name'
      },
      {
        text: 'Method',
        align: 'start',
        value: 'method',
        sortable: true,
        filterable: true,
      },
      {
        text: 'Created',
        align: 'start',
        value: 'created'
      },
      {
        text: 'Status',
        align: 'start',
        value: 'status',
        filterable: true,
      },
      {
        text: 'Actions',
        value: 'actions',
        align: 'end',
        sortable: false
      }
    ],
    options: {
      itemsPerPage: 10,
      sortBy: ['created'],
      sortDesc: [true],
      multiSort: false,
      mustSort: true
    },
    footer: {
      itemsPerPageOptions: [5, 10, 20, -1],
      showFirstLastPage: true,
      showCurrentPage: true,
      itemsPerPageAllText: "All",
    },
    filterMethod: [],
    filterStatus: [],
    clearFilter: false,
    nodata: 'No data found!',
    search: '',
    notificationMethods: [
      {
        name: "Notification drawer",
        id: "websend"
      },
      {
        name: "Important notices banner",
        id: "banner"
      }
    ],
    notificationStatuses: [
      {
        name: 'Draft',
        id: 'Draft'
      },
      {
        name: 'Pending',
        id: 'Pending'
      },
      {
        name: 'Rejected',
        id: 'Rejected'
      },
      {
        name: 'Scheduled',
        id: 'Scheduled'
      },
      {
        name: 'Sent',
        id: 'Sent'
      }
    ],
  }),
  computed: {
    notifications: {
      get() {
        return this.$store.state.notifications.filter(item => item.appName === 'qplus')
      },
    },
    currentNotification() {
      return this.$store.state.notification;
    },
    filters() {
      return {
        method: this.filterMethod,
        status: this.filterStatus
      }
    }
  },
  methods: {
    clearAllFilters() {
      this.filterMethod = [];
      this.filterStatus = [];
      this.clearFilter = true;
    }
  },
  created() {
    this.$store.commit('setNotification', null);
    this.$store.commit('setNotificationSetupDetails', null);
    this.$store.commit('setNotificationMessageDetails', null);
    this.$store.commit('setNotificationAudienceAndScheduling', null);
    this.$store.commit('setNotificationInfo', null);
    this.$store.dispatch('fetchNotifications');
  }
};
</script>

<style lang="scss" scoped>

.rowAlignCenter {
  display: flex;
  align-items: center;
}

.chipFiltersContainer {
  display: flex;
  flex-wrap: nowrap;
  width: calc(100% + 12px);
  overflow-x: scroll;
}

.chipFiltersContainer::-webkit-scrollbar {
  display: none;
}

</style>
